import { render, staticRenderFns } from "./IconLandscape.vue?vue&type=template&id=644d8e36&"
import script from "./IconLandscape.vue?vue&type=script&lang=js&"
export * from "./IconLandscape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644d8e36')) {
      api.createRecord('644d8e36', component.options)
    } else {
      api.reload('644d8e36', component.options)
    }
    module.hot.accept("./IconLandscape.vue?vue&type=template&id=644d8e36&", function () {
      api.rerender('644d8e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLandscape.vue"
export default component.exports